<ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div cdkDragHandle class="mep-dialog-header-icon">
		<mat-icon> date_range</mat-icon>
	</div>

	<div class="mep-dialog-title">{{ _lang("heading") }}</div>
	@if (gotUser) {
		<div class="mt-2 full-height-dialog-content mep-dialog-content" mat-dialog-content>
			@if (loading) {
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			}
			<div class="col">
				<div>
					<!-- Choose project -->
					<mat-form-field class="w-100">
						<mat-label>{{ "mep.components.general.project" | translate }}</mat-label>
						<input
							#projectInput
							[disabled]="!!data"
							[matAutocomplete]="auto.matAutocomplete"
							[ngModel]="project"
							[placeholder]="_lang('please')"
							[readonly]="!!data"
							matInput
							required
						/>
						<app-project-autocomplete
							#auto
							(elementSelected)="onProjectSelectionChanged($event)"
							[inputElement]="projectInput"
							[overflow]="false"
							[onlyProjectsWithEditRights]="
								!(
									authenticationService.isMepAdmin() ||
									authenticationService.isBusinessUnitManager() ||
									authenticationService.isBusinessUnitLeader() ||
									authenticationService.isExecutive() ||
									authenticationService.isDepartmentManager()
								)
							"
						></app-project-autocomplete>
					</mat-form-field>
				</div>
				<div class="d-flex mt-4">
					<h3 class="mb-0 flex-grow-1">{{ _lang("edit-project") }}</h3>
					<mat-icon [matTooltip]="_lang('assignment-table-tooltip')" class="assignment-table-info-icon"> info</mat-icon>
				</div>
				<mat-button-toggle-group
					(ngModelChange)="onOperationChanged($event)"
					[ngModel]="moveProject"
					[disabled]="!project"
					class="d-flex mt-3 mb-3 mep-toggle-button-container"
				>
					<mat-button-toggle [value]="false" class="flex-grow-1 mep-toggle-button" disableRipple
						>{{ _lang("operation-extend") }}
					</mat-button-toggle>
					<mat-button-toggle [value]="true" class="flex-grow-1 mep-toggle-button" disableRipple
						>{{ _lang("operation-move") }}
					</mat-button-toggle>
				</mat-button-toggle-group>
				@if (!moveProject) {
					<div class="row">
						<mat-form-field class="col-4">
							<mat-label>{{ _lang("old-project-start") }}</mat-label>
							<input [value]="(projectStart | date: 'dd.MM.yyyy') || '-'" disabled matInput />
						</mat-form-field>
						<mat-form-field class="col-4">
							<mat-label>{{ _lang("old-project-end") }}</mat-label>
							<input [value]="(oldProjectEnd | date: 'dd.MM.yyyy') || '-'" disabled matInput />
						</mat-form-field>
						<mat-form-field class="col-3">
							<mat-label>{{ _lang("old-project-probability") }}</mat-label>
							<input [value]="oldProjectProbability || '-'" class="text-end" disabled matInput />
							<span matSuffix>&nbsp;%</span>
						</mat-form-field>
					</div>
				}
				@if (moveProject) {
					<mat-select
						class="project-time-slice-select"
						(ngModelChange)="onSelectedProjectTimeSliceChanged($event)"
						[ngModel]="selectedProjectTimeSlice"
					>
						<mat-select-trigger>
							<div class="row white-space-normal">
								<mat-form-field class="col-4">
									<mat-label>{{ _lang("old-project-start") }}</mat-label>
									<input
										[value]="(selectedProjectTimeSlice?.effectiveFrom | date: 'dd.MM.yyyy') || '-'"
										class="cursor-pointer"
										disabled
										matInput
									/>
								</mat-form-field>
								<mat-form-field class="col-4">
									<mat-label>{{ _lang("old-project-end") }}</mat-label>
									<input
										[value]="(selectedProjectTimeSlice?.effectiveUntil | date: 'dd.MM.yyyy') || '-'"
										class="cursor-pointer"
										disabled
										matInput
									/>
								</mat-form-field>
								<mat-form-field class="col-3">
									<mat-label>{{ _lang("old-project-probability") }}</mat-label>
									<input
										[value]="selectedProjectTimeSlice?.probability || '-'"
										class="text-end cursor-pointer"
										disabled
										matInput
									/>
									<span matSuffix>&nbsp;%</span>
								</mat-form-field>
							</div>
						</mat-select-trigger>
						@for (projectTimeSlice of projectTimeSlices; track projectTimeSlice) {
							<mat-option [value]="projectTimeSlice">
								{{ projectTimeSlice.effectiveFrom | date: "dd.MM.yyyy" }}
								- {{ projectTimeSlice.effectiveUntil | date: "dd.MM.yyyy" }} ({{ projectTimeSlice.probability }}
								%)
							</mat-option>
						}
					</mat-select>
				}
				<div class="row mt-3">
					<!--New project start-->
					@if (moveProject) {
						<mat-form-field class="col-4 mat-form-field-error-not-absolute align-self-start">
							<mat-label>{{ _lang("new-project-start") }}</mat-label>
							<input
								(dateInput)="onNewProjectStartChanged($event.targetElement.value)"
								[formControl]="newProjectStart"
								[matDatepicker]="pickerFrom"
								[readonly]="!projectStart"
								appOnlyNumbers
								autocomplete="off"
								matInput
								required
							/>
							<mat-datepicker-toggle [for]="pickerFrom" matSuffix></mat-datepicker-toggle>
							<mat-datepicker
								#pickerFrom
								[startAt]="newProjectStart.value ? newProjectStart.value : selectedProjectTimeSlice?.effectiveFrom"
							></mat-datepicker>
							@if (newProjectStart.errors; as errors) {
								<mat-error>
									@if (errors["startAfterEnd"]) {
										{{ _lang("error.new-start-after-end") }}
									}
									@if (errors["withinExistingTimeSlice"]; as timeSlice) {
										{{ _lang("error.within-existing-time-slice") }}
										<br />
										{{ timeSlice.effectiveFrom | date: "dd.MM.yyyy" }}
										- {{ timeSlice.effectiveUntil | date: "dd.MM.yyyy" }} ({{ timeSlice.probability }}
										%)
									}
								</mat-error>
							}
						</mat-form-field>
					} @else {
						<span class="col-4"></span>
					}
					<!--New project end-->
					<mat-form-field class="col-4 mat-form-field-error-not-absolute align-self-start">
						<mat-label>{{ _lang("new-project-end") }}</mat-label>
						<input
							(dateInput)="onNewProjectEndChanged($event.targetElement.value)"
							[formControl]="newProjectEnd"
							[matDatepicker]="pickerUntil"
							[readonly]="!projectStart"
							appOnlyNumbers
							autocomplete="off"
							matInput
							required
						/>
						<mat-datepicker-toggle [for]="pickerUntil" matSuffix></mat-datepicker-toggle>
						<mat-datepicker
							#pickerUntil
							[startAt]="newProjectEnd.value ? newProjectEnd.value : oldProjectEnd"
						></mat-datepicker>
						@if (newProjectEnd.errors; as errors) {
							<mat-error>
								@if (errors["newProjectEndCutsOffAssignment"]) {
									<strong>{{ _lang("error.during-assignments") }}</strong>
									<br />
									<ul>
										@for (assignment of errors["newProjectEndCutsOffAssignment"]; track assignment) {
											<li>
												{{ assignment.employee.lastName + " " + assignment.employee.firstName }}
												({{ assignment.effectiveFrom | date: "dd.MM.yy" }} -
												{{ assignment.effectiveUntil | date: "dd.MM.yy" }} , {{ assignment.capacity }}
												%)
											</li>
										}
									</ul>
								}
								@if (errors["oldProjectEndAfterNew"]) {
									{{ _lang("error.old-project-end-after-new") }}
								}
								@if (errors["withinExistingTimeSlice"]; as timeSlice) {
									{{ _lang("error.within-existing-time-slice") }}
									<br />
									{{ timeSlice.effectiveFrom | date: "dd.MM.yyyy" }}
									- {{ timeSlice.effectiveUntil | date: "dd.MM.yyyy" }} ({{ timeSlice.probability }}
									%)
								}
							</mat-error>
						}
					</mat-form-field>
					<mat-form-field class="col-3 align-self-start">
						<mat-label>{{ _lang("new-project-probability") }}</mat-label>
						<input
							[formControl]="newProjectProbability"
							[readonly]="!projectStart"
							appOnlyNumbers
							autocomplete="off"
							class="text-end"
							matInput
							required
						/>
						<span matSuffix>&nbsp;%</span>
					</mat-form-field>
				</div>
				@if (project) {
					@if (noAssignments) {
						<h3 class="mt-4">{{ _lang("no-assignments") }}</h3>
					} @else {
						<h3 class="mb-0">{{ _lang("assignment-table-title-" + (moveProject ? "move" : "extend")) }}</h3>
						<h4 class="mat-h4">{{ _lang("assignment-table-sub-title") }}</h4>
					}
				}
				<div [class.d-none]="noAssignments || !project" class="mat-elevation-z3 mb-3">
					<app-assignment-table
						(updateValidation)="updateValidation($event)"
						[project]="project"
					></app-assignment-table>
				</div>
			</div>
		</div>
	}
	@if (!gotUser) {
		<div class="mep-dialog-content" mat-dialog-content>
			<span>{{ _lang("noUserFound") }}</span>
		</div>
	}
	<div class="mep-dialog-actions">
		<button (click)="closeDialog()" appEscapeHotkey class="mep-btn-dialog-secondary">{{ _lang("cancel") }}</button>
		@if (gotUser) {
			<button
				(click)="saveChanges()"
				[disabled]="saveButtonDisable()"
				[matTooltip]="_lang('save-tooltip')"
				appSaveHotkey
				class="mep-btn-dialog-primary"
			>
				{{ _lang("save") }}
			</button>
		}
	</div>
</ng-container>
